module.exports = __webpack_public_path__ + "images/exclamation.83051c6.png";